import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Header from "./Header";
import "./CompanyPages.css";

const News = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="home">
      <Header />
      <main className="wc-info">
        <div className="wc-info-container">
          <div className="wc-info-intro">
            <p className="wc-info-eyebrow">NEWS</p>
            <h1 id="press">お知らせ</h1>
            <p className="wc-info-lead">ワンダーコムズのサービスに関する情報をお届けします。</p>
          </div>
          <article className="wc-info-news">
            <div className="wc-info-news-meta"><time dateTime="2026-09-09">2026.09.09</time><span>サービスのご案内</span></div>
            <h2>社内ツールの改修・運用支援「つくったあと」のご案内</h2>
            <p>AIで作った社内ツールを、これからも業務で使い続けるために。「つくったあと」は、ツールの改修と運用を支援するサービスです。</p>
            <p>「修正したいけれど、どこを触ればよいか分からない」「誰が使えて、データがどこに保存されているか確認したい」。そんなお困りごとからご相談いただけます。</p>
            <p>利用権限、保存先、費用、更新・引き継ぎの方法を確認し、必要な対応を一緒に整理します。サービスの詳細は、紹介ページをご覧ください。</p>
            <Link className="wc-info-button" to="/shikumi-seibi">「つくったあと」を見る<span aria-hidden="true">→</span></Link>
          </article>
        </div>
      </main>
    </div>
  );
};

export default News;
